import { createFileRoute, Link } from "@tanstack/react-router";
import { workflows } from "@/data";
import { useActionStore } from "@/state/ActionStore";
import { WorkflowComposeView } from "@/components/views/workflow/WorkflowComposeView";

export const Route = createFileRoute("/workflows/compose/$workflowId")({
  component: ComposeEditRoute,
});

function ComposeEditRoute() {
  const { workflowId } = Route.useParams();
  const { sessionDraftWorkflows } = useActionStore();
  const wf =
    sessionDraftWorkflows.find((w) => w.slug === workflowId) ??
    workflows.find((w) => w.slug === workflowId);
  if (!wf) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <div className="text-foreground text-[13px]">Workflow not found</div>
          <Link
            to="/workflows"
            className="text-primary mt-1 inline-block text-[12px] hover:underline"
          >
            ← Back to Workflows
          </Link>
        </div>
      </div>
    );
  }
  return <WorkflowComposeView initial={wf} sourceWorkflowId={wf.id} />;
}
